// import { AntDesignOutlined } from "@ant-design/icons";
import { notification } from 'antd'
import axios from 'axios'

// const qs = require('querystring')

const apiRoot = process.env.REACT_APP_API_URL

const fsConfig = {
  root: apiRoot,
  getSites: '/catalog/site',
  opSite: '/catalog/site',
}

// get Sites
export async function getSites(token) {
  const auth = `Bearer ${token}`
  // console.log('auth:', auth)
  const url = fsConfig.root + fsConfig.getSites
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: auth,
    },
  }
  return axios
    .get(url, newConfig)
    .then(response => {
      const result = response.data.map((el, ndx) => {
        const o = Object.assign({}, el)
        o.key = `${ndx + 1}`

        // el usuario lo hago objeto
        o.user = JSON.parse(o.user)

        return o
      })
      response.data = result
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error obteniendo ubicaciones',
        description: error.message,
      })
    })
}

// add new site
export async function postSite(token, site) {
  const url = fsConfig.root + fsConfig.opSite
  const newConfig = {
    headers: {
      'Content-Type': 'application/json',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }

  // borra los campos auxiliares que no se graban
  delete site.userMaster

  return axios
    .post(url, site, newConfig)
    .then(response => {
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error agregando ubicación',
        description: error.message,
      })
    })
}

export async function putSite(token, site) {
  const url = fsConfig.root + fsConfig.opSite
  const newConfig = {
    headers: {
      'Content-Type': 'application/json',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  const { key } = site
  delete site.key
  delete site.userMaster
  delete site.user

  return axios
    .put(url, site, newConfig)
    .then(response => {
      response.key = key
      return response
    })
    .catch(error => {
      console.log('Error:', error)
      notification.warning({
        message: 'Error grabando ubicación',
        description: error.message,
      })
    })
}

export async function deleteSite(token, SiteUid) {
  const url = `${fsConfig.root}${fsConfig.opSite}/${SiteUid}`
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  return axios
    .delete(url, newConfig)
    .then(response => {
      const { result } = response.data
      return result
    })
    .catch(error => {
      notification.warning({
        message: 'Error eliminando ubicación',
        description: error.message,
      })
    })
}
